export default __webpack_public_path__ + "images/error.v-b367c0b3733c7856707063064ace2f71.svg";